var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome } from '@fortawesome/free-solid-svg-icons/faHome';
import styled from '@emotion/styled';
import { Container } from '../../layout';
var BreadcrumbContainer = styled(Container)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 5.72rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n"], ["\n  height: 5.72rem;\n  position: relative;\n  display: flex;\n  align-items: center;\n"])));
var BreadcrumbIcon = styled(FontAwesomeIcon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  &.svg-inline--fa {\n    color: ", ";\n    cursor: pointer;\n    width: 1.29rem;\n    height: 1.29rem;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"], ["\n  &.svg-inline--fa {\n    color: ", ";\n    cursor: pointer;\n    width: 1.29rem;\n    height: 1.29rem;\n\n    &:hover {\n      color: ", ";\n    }\n  }\n"])), function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.action;
}, function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.actionStrong;
});
export var Breadcrumb = function (props) {
    return <BreadcrumbContainer data-testid="breadcrumb" {...props}/>;
};
// Breadcrumb Icons
export var BreadcrumbHomeIcon = function (props) { return (<BreadcrumbIcon data-testid="home-icon" icon={faHome} {...props}/>); };
var templateObject_1, templateObject_2;
